import api from './api';
import {
  Referral,
  ReferralFilters,
  ReferralStats,
  CreateReferralData,
  BrokerSearchResult,
  ReferralTimeline,
} from '@/types/referral.types';
import { PaginatedResponse, ReferralResponse, TimelineResponse } from '@/types';

export const referralsService = {
  // Get all referrals with filters and pagination
  getAll: (filters?: ReferralFilters, page = 1, limit = 20) =>
    api.get<PaginatedResponse<Referral>>('/referrals', {
      params: { ...filters, page, limit },
    }),

  // Get single referral by ID - returns { referral: {...} }
  getById: (id: string) =>
    api.get<ReferralResponse>(`/referrals/${id}`),

  // Get referral stats - returns stats directly (after interceptor unwrap)
  getStats: () =>
    api.get<ReferralStats>('/referrals/stats'),

  // Get pending referrals count
  getPendingCount: () =>
    api.get<{ count: number }>('/referrals/pending-count'),

  // Search brokers for referral
  searchBrokers: (query: string) =>
    api.get<BrokerSearchResult[]>('/referrals/search-brokers', {
      params: { query },
    }),

  // Create a new referral
  create: (data: CreateReferralData) =>
    api.post<Referral>('/referrals', data),

  // Accept a referral
  accept: (id: string) =>
    api.post<Referral>(`/referrals/${id}/accept`),

  // Reject a referral
  reject: (id: string, reason: string) =>
    api.post<Referral>(`/referrals/${id}/reject`, { reason }),

  // Mark referral as completed
  complete: (id: string) =>
    api.post<Referral>(`/referrals/${id}/complete`),

  // Cancel a referral
  cancel: (id: string) =>
    api.post<Referral>(`/referrals/${id}/cancel`),

  // Get referral timeline - returns { timeline: [...] }
  getTimeline: (id: string) =>
    api.get<TimelineResponse<ReferralTimeline>>(`/referrals/${id}/timeline`),
};

export default referralsService;
